import { useCallback, useEffect, useState } from 'react';
import {
  deployLoaded, deployOffOf, loadDeployFlags, saveDeploy, subscribeDeployFlags,
} from '../utils/deployFlags';

/**
 * The project's Deploy switches (utils/deployFlags.js): `{ off, loaded, isDeployed(name), setDeploy(name, on) }`; `off`
 * the short names of the services not deployed, `isDeployed` true for every other service (the default).
 */
export default function useDeployFlags(projectId) {
  const [state, setState] = useState(() => ({ off: deployOffOf(projectId), loaded: deployLoaded(projectId) }));
  useEffect(() => {
    if (!projectId) { setState({ off: [], loaded: false }); return undefined; }
    setState({ off: deployOffOf(projectId), loaded: deployLoaded(projectId) });
    const unsubscribe = subscribeDeployFlags(projectId, (off) => setState({ off, loaded: true }));
    loadDeployFlags(projectId);
    return unsubscribe;
  }, [projectId]);
  const isDeployed = useCallback((name) => !state.off.includes(String(name || '').replace(/^services\//, '')), [state.off]);
  const setDeploy = useCallback((name, on) => saveDeploy(projectId, name, on), [projectId]);
  return { off: state.off, loaded: state.loaded, isDeployed, setDeploy };
}
